import { alpha } from '@mui/material';
/**
 * MuiChip
 */
const MuiChip = {
  styleOverrides: {
    deletable: ({
      theme
    }) => ({
      '& .MuiChip-deleteIcon': {
        fontSize: theme.typography.pxToRem(16),
        marginRight: theme.spacing()
      }
    }),
    clickable: ({
      theme
    }) => ({
      '&.MuiChip-clickable:hover': {
        backgroundColor: theme.palette.primary[200]
      }
    }),
    // @ts-expect-error MUI theme is not exposing this type but it's correct
    filledDefault: ({
      theme
    }) => ({
      backgroundColor: theme.palette.primary[200],
      color: theme.palette.text.primary,
      '& 	.MuiChip-deleteIcon': {
        color: theme.palette.primary.light
      },
      '& 	.MuiChip-deleteIcon:hover': {
        color: theme.palette.primary.main
      }
    }),
    // @ts-expect-error MUI theme is not exposing this type but it's correct
    outlinedDefault: ({
      theme
    }) => ({
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.primary[200]}`
    }),
    status: {
      height: 24
    },
    // For status chips
    // https://www.figma.com/file/0G8XaPJgQv9u3gmAGA4Alw/System-Health?node-id=14%3A9565&mode=dev
    // @ts-expect-error
    statusDefault: ({
      theme
    }) => ({
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.text.secondary
    }),
    // @ts-expect-error
    statusPrimary: ({
      theme
    }) => ({
      backgroundColor: theme.palette.primary[100],
      color: theme.palette.primary.main
    }),
    // @ts-expect-error
    statusSecondary: ({
      theme
    }) => ({
      backgroundColor: theme.palette.quaternary.light,
      color: theme.palette.quaternary.dark
    }),
    // @ts-expect-error
    statusError: ({
      theme
    }) => ({
      backgroundColor: theme.palette.error[100],
      color: theme.palette.error.main
    }),
    // @ts-expect-error
    statusInfo: ({
      theme
    }) => ({
      backgroundColor: alpha(theme.palette.info.main, 0.1),
      color: theme.palette.info.main
    }),
    // @ts-expect-error
    statusSuccess: ({
      theme
    }) => ({
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.dark
    }),
    // @ts-expect-error
    statusWarning: ({
      theme
    }) => ({
      backgroundColor: theme.palette.warning.light,
      color: theme.palette.warning.dark
    })
  }
};
export default MuiChip;